
export default {
  'formActions': {
    'addPlaceInput': 'Ajouter un champ de lieu',
    'clearRoute': 'Effacer l\'itinéraire',
    'reverseRoute': 'Inverser la route',
    'roundTrip': 'Route circulaire',
    'toggleRoundTrip': 'Basculer route circulaire'
  },
}
